
import { createGlobalStyle } from 'styled-components';

const HelpStyles = createGlobalStyle`
.help-container {

    .help-center__back-button {
        font-size: 0.889rem;
        font-family: "National2 Narrow";
        font-weight: 700;
        margin-top: 20px;
        margin-bottom: 40px;
        padding: 0 95px 0 45px;
        text-transform: uppercase;
        a {
            color: #000;
            text-decoration: none;
        }
        a:focus, a:hover {
            color: ${props => props.theme.red};
            text-decoration: underline;
        }
    }

    .related-questions__title {
        font-family: ${props => props.theme.fontFamilySerif};
        font-size: 1.5rem;
        margin-bottom: 15px;
        color: ${props => props.theme.red};
        line-height: 1.1;
    }

    .related-questions__links a {
        font-family: ${props => props.theme.fontFamilySansSerif};
        font-size: 1rem;
        font-weight: 300;
        line-height: 1;
        color: #000;
        text-decoration: none;

        &:hover, &:focus {
            text-decoration: underline;
        }
    }
}
`;

export default HelpStyles;